import { environment } from "../config/environment";
import { fetchJson } from "../../fetch";
import { isServer } from "../../utils";

export class EngagementPromoService {
  private static getEngagementPromos() {
    return fetchJson(
      `${environment.AARP_CONST_BLOB}/${environment.AARP_ENV}/json/EngagementPromo.json`,
      { timeout: 10 * 1000 }
    ).catch((err) => {
      console.error(err);
      throw new Error("Unable to fetch Cross Promotions.\n" + err.stack);
    });
  }

  public static async getPromoByDateAndGameID(gameID: string) {
    if (isServer) return null;
    const allPromos = await this.getEngagementPromos()
    
    const today = new Date().getTime();
    const selectedPromos = allPromos.filter((promo) => {
      const firstPromoDate = new Date(promo.eventDateStart).setHours(0, 0, 0);
      const lastPromoDate = new Date(promo.eventDateEnd).setHours(23, 59, 59);
      return (
        firstPromoDate <= today &&
        lastPromoDate >= today &&
        promo.gameIDs.some((id) => id === gameID || id === "all")
      );
    });
    if (!selectedPromos.length) {
      return null;
    } else {
      const clonedPromo = JSON.parse(
        JSON.stringify(selectedPromos[0])
      );
      return clonedPromo;
    }
  }
}
